export default "__VITE_ASSET__D2v94f13__";